import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import getColorByRating from '@utils/review/getColorByRating';
import RatingText from '@components/Rating/components/RatingText';
import RatingIcon from './components/StarFilledIcon';
import formatRatingValue from './utils/formatRatingValue';

const StyledRatingText = styled(RatingText)`
  height: 16px;
  margin: 0 0 0 3px;
  ${({ theme }) => theme.fontFamily.mainFont.xSmallExtraBold};
  line-height: 1.43;
`;

const StyledRatingContainer = styled.div`
  display: flex;
  flex-direction: 'row';
  height: 21px;
  border-radius: 4px;
  margin: 0 0 1px 12px;
  padding: 1px 5px 3px 4px;
  box-sizing: border-box;
  background-color: ${props => props.backgroundColor};
`;

function Rating({ score, className, ...props }) {
  const formattedScore = formatRatingValue(score);
  const { textColor: color, backgroundColor } = getColorByRating(
    parseFloat(score),
  );
  return (
    <StyledRatingContainer
      className={className}
      backgroundColor={backgroundColor}
      {...props}
    >
      <RatingIcon color={color} />
      <StyledRatingText color={color} className={className}>
        {formattedScore}
      </StyledRatingText>
    </StyledRatingContainer>
  );
}

Rating.defaultProps = {
  className: '',
};

Rating.propTypes = {
  score: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  className: PropTypes.string,
};

export { getColorByRating };

export default styled(Rating)``;
